export default __webpack_public_path__ + "static/media/logoVJCET.b32b8681.png";